import styled, { keyframes } from "styled-components";

export const ButtonGroup = styled.div`
    align-self: center;
    display: flex;
    gap: 10px;
    margin-top: 2rem;
    margin-bottom: 10px;
`;

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 15px;
    margin-top: -10px;
    min-width: 0;
`;

export const FormContainer = styled.form`
  border-radius: 12px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(234, 235, 234, 1);
  background-color: #f9fafb;
  display: flex;
  width: 100%;
  max-width: 700px;
  flex-direction: column;
  color: #000;
  padding: 8px 32px;
  margin-top: 100px;
  margin-bottom: 100px;
  overflow-y: auto;          /* Enable vertical scroll if needed */
  overflow-x: hidden;        /* Prevent children from making form wider than viewport */
  max-height: 90vh;          /* Prevent form from growing too tall */
  box-sizing: border-box;
  min-width: 0;

  @media (max-width: 991px) {
    padding: 0 20px;
  }

  @media (max-width: 600px) {
    padding: 8px 16px;
    margin-top: 16px;
    margin-bottom: 16px;
    max-height: calc(100vh - 32px);
  }

  .activity-name-input {
    color: #969a97;
    font-family: 'Inter', sans-serif;
  font-size: 20px;
  font-weight: 500;
    padding-top: 15px;
    padding-bottom: 10px;
    @media (max-width: 991px) {
      max-width: 100%;
    }
  }

  .section-title {
    margin-top: 8px;
    margin-bottom: 5px;
    font: 500 16px Inter, sans-serif;
    @media (max-width: 991px) {
      max-width: 100%;
    }
  }

  .label-title,
  .description-title {
    margin-top: 14px;
    font: 16px Inter, sans-serif;
  }
`;

export const Divider = styled.hr`
  border: none;
  border-top: 2px dashed rgb(192, 192, 192);
  margin-top: 8px;
  margin-bottom: 8px;
  width: 100%;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

export const DescriptionSection = styled.textarea`
    border-radius: 10px;
    border: 1px solid rgba(234, 235, 234, 1);
    background-color: rgb(255, 255, 255) ;
    margin-top: 8px;
    margin-bottom: 8px;
    color:rgb(81, 83, 81);
    padding: 10px 10px;
    font: 500 14px Inter, sans-serif;
    width: 100%;
    min-height: 100px;
    resize: vertical;

    &::placeholder {
      color: #969a97; /* Placeholder color */
      opacity: 1;     /* Ensures full visibility across browsers */
    }

    @media (max-width: 991px) {
        max-width: 100%;
        padding-right: 20px;
    }

    &:focus {
    outline: none;
    border-color: #6366f1;
    box-shadow: 0 0 0 2px #c7d2fe;
  }
`;

export const Button = styled.button`
  border-radius: 9999px;
  color: #fff;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  padding: 11px 28px;
  margin-top: 1rem;
  cursor: pointer;
  border: none;
  background-color: rgb(83, 74, 245);
  transition: background-color 0.15s ease-in-out, transform 0.1s ease;
  &:hover {
    background-color: rgb(70, 60, 220);
  }
  &:active {
    transform: scale(0.95);
  }

  @media (max-width: 991px) {
    padding: 11px 20px;
  }
`;


const BaseButton = styled.button`
  width: 100%;
  font-weight: 600;
  padding: 11px 28px;
  border-radius: 9999px;
  color: white;
  border: none;
  cursor: pointer;
  transition: background-color 0.15s ease-in-out, transform 0.1s ease;

  &:active {
    transform: scale(0.95);
  }

  &:focus-visible {
    outline: 2px solid ${({ $ringColor }) => $ringColor || 'currentColor'};
    outline-offset: 2px;
  }

  @media (max-width: 991px) {
    padding: 11px 20px;
  }
`;

// Cancel button (red)
export const CancelButton = styled(BaseButton)`
  background-color: #ef4444;

  &:hover {
    background-color: #dc2626;
  }

  &:focus {
    box-shadow: 0 0 0 2px #ef444450;
  }
`;

export const SubmitButton = styled(BaseButton)`
  background-color: #22c55e;

  &:hover {
    background-color: #16a34a;
  }

  &:focus {
    box-shadow: 0 0 0 2px #22c55e50;
  }
`;

export const ActivityNameInput = styled.input`
  border: none;
  outline: none;
  font: inherit;
  color: inherit;
  width: 100%;
  background: transparent;
  ::placeholder {
    color: #969a97;
  }
`;

export const RepoInfoRow = styled.div`
  display: block;
  font-size: 0.6rem;
  font-weight: 600;
  color: #6b7280; /* Tailwind gray-500 */
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.5rem;
`;

export const RepoNameTag = styled.span`
  padding: 4px 8px;
  border-radius: 9999px;
  font-weight: 700;
  font-size: 0.7rem;
  color: ${({ $match }) => ($match ? "#16a34a" : "#f59e0b")};  /* dark green / dark yellow */
`;

export const SectionTitle = styled.h3`
  display: flex;
  color: #374151;
  margin-bottom: 0.5rem;
  align-items: center;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 600;
  gap: 0.75rem;

  margin-top: 16px;
  margin-bottom: 5px;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

export const Title = styled.h2`
  font-size: 1.875rem;
  font-weight: 600;
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
`;

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const AddRow = styled.div`
  display: flex;
  gap: 0.75rem;
  align-items: center;
`;

export const DocInput = styled.input`
  flex: 1;
  padding: 12px 16px;
  font-size: 14px;
  height: 48px; 
  border-radius: 10px;
  border: 1px solid #e4e4e4;
  transition: border-color 0.2s ease;

  &:focus {
    outline: none;
    border: 2px solid #534af5;
  }
`;

export const EmptyText = styled.div`
  color: #6b7280;
  font-size: 0.875rem;
`;

export const AddDocButton = styled.button`
  display: inline-flex;
  align-items: center; 
  justify-content: center;
  gap: 0.35rem; /* spacing between icon and text */
  font-size: 0.95rem;
  font-weight: 600;
  color: #534af5;
  background: transparent;
  border: none;
  cursor: pointer;
  line-height: 1;
  transition: transform 0.2s ease;

  .icon svg{
    display: block; 
    align-items: center; /* centers SVG inside span */
    font-size: 1.4rem;
    transform-origin: center;
    transition: transform 0.2s ease;
  }

  .span {
    display: flex;
    align-items: center;
    gap: 0.25rem;
  }

  &:hover .icon svg{
    transform: scale(1.05);
  }

  &:hover {
    color: #352befff;
  }
`;


export const FetchSummaryWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1.25rem;
  margin-top: 0.05rem;
  font-size: 0.9rem;
  border: none;
  font-weight: 400;
  background: #f9fafb; /* light neutral background */
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
`;

export const SummaryItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  color: ${({ $type }) => ($type === "success" ? "#16a34a" : "#dc2626")};
`;

export const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const SavingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${fadeIn} 0.3s ease-in-out;
  z-index: 3000;
`;

export const SavingBox = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 24px 48px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.25);
  text-align: center;
  max-width: 340px;
`;

export const SpinnerRotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const Spinner = styled.div`
  border: 3px solid #e0e0e0;
  border-top: 3px solid #4f46e5;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  animation: ${SpinnerRotate} 1s linear infinite;
  margin: 12px auto;
`;

export const SavingTitle = styled.h3`
  margin-bottom: 8px;
  color: #333;
  font-weight: 600;
  font-size: 1.1rem;
`;

export const SavingText = styled.p`
  color: #666;
  font-size: 0.9rem;
  margin: 0;
`;

export const LinkGoogleBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fefce8;
  border: 1px solid #fef08a;
  color: #a16207;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 0.875rem;
  margin-bottom: 8px;
`;

export const LinkGoogleButton = styled.button`
  margin-left: auto;
  padding: 6px 14px;
  background: #534af5;
  color: white;
  border: none;
  border-radius: 9999px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.15s ease, transform 0.1s ease;

  &:hover {
    background: #4338ca;
  }
  &:active {
    transform: scale(0.95);
  }
`;
